import {
  withStyles,
} from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Colors from "./colors"

const lightButton = withStyles((theme) => ({
  root: {
    backgroundColor: Colors.buttonColor,
    "&:hover": {
      backgroundColor: Colors.primaryColor,
    },
  },
  label: {
    color: Colors.buttonTextColor
  }
}))(Button);

export default lightButton
